import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'

import styled from 'styled-components'
import { isEmpty, flatten } from 'lodash'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TrashOIcon } from '@10xLabs/react-web/components/Icons/TrashO'
import EmptyState from 'components/v2/EmptyState'
import { Loader } from '@10xLabs/react-web/components/Loader'
import { Button } from 'components/v2/Button'
import { Input } from 'components/Input'
import { TableContainer, Table, Thead, Th, Tbody, Td } from '@10xLabs/react-web/components/Table'
import { InputCurrency } from 'components/InputCurrency'
import { Switch } from 'components/v2/Switch'
import { getFareByTaxonomy } from 'resolvers/fares'
import { seasonTypeMessages } from 'features/SeasonEvents/components/SeasonType/messages'
import { FARE_TYPE } from 'features/FareFamilies/components/FareType/constants'
import { fareTypeMessages } from 'features/FareFamilies/components/FareType/messages'
import { dowMessages } from 'features/FareFamilies/components/Dow/messages'
import { demandMessages } from 'features/FareFamilies/components/Demand/messages'
import { salesChannelMessages } from 'features/FareFamilies/components/SalesChannel/messages'
import { serviceTypeMessages } from 'features/FareFamilies/components/ServiceType/messages'
import { sanitizePrice } from 'utils/math'

const Tr = styled.tr<TSFixMe>`
  background-color: #ffffff;
`

const StyledTd = styled(Td)<TSFixMe>`
  padding: ${(props): TSFixMe => (props.isFirstRow ? '20px 10px 10px' : '10px')};

  input {
    width: calc(100% - 20px);
    min-width: ${(props): TSFixMe => (props.largeInput ? '84px' : '50px')};
    font-size: 14px;
  }
`

const TrashWrapper = styled.div<TSFixMe>`
  display: flex;
  cursor: pointer;
`

const StyledTrashOIcon = styled(TrashOIcon)<TSFixMe>`
  fill: #1976d2;
  width: 18px;
  height: 22px;
`

const GET_BOOKING_CLASSES = gql`
  query GetBookingClasses($companyId: ID!) {
    bookingClasses(input: { companyID: $companyId }) {
      id
      name
      promo
      isActive
    }
  }
`

const FaresTable = (props: TSFixMe): TSFixMe => {
  const { values, touched, errors, setFieldValue, bookingClasses, setFieldTouched, handleBlur } = props

  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="dictionary.taxonomy" defaultMessage="Taxonomy" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.bookingClass" defaultMessage="Booking Class" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.fareType" defaultMessage="Fare Type" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.season" defaultMessage="Season" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.timeWindow" defaultMessage="Time Window" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.dayOfWeek" defaultMessage="Day of Week" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.demand" defaultMessage="Demand" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.salesChannel" defaultMessage="Sales channel" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.serviceType" defaultMessage="Service type" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.total" defaultMessage="Total" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.status" defaultMessage="Status" />
            </Th>
            <Th />
          </Tr>
        </Thead>

        <Tbody>
          {values.fares.map((fare: TSFixMe, index: TSFixMe): TSFixMe => {
            const handleTaxonomyChange = ({ target: { value } }: TSFixMe): TSFixMe => {
              value = value.toUpperCase()
              setFieldValue(`fares[${index}]`, {
                ...fare,
                taxonomy: value,
                ...getFareByTaxonomy(value, bookingClasses)
              })
            }

            const handleTaxonomyBlur = (): TSFixMe => {
              setFieldTouched(`fares[${index}].bookingClass.id`, true)
              setFieldTouched(`fares[${index}].type`, true)
              setFieldTouched(`fares[${index}].seasonType`, true)
              setFieldTouched(`fares[${index}].timeWindow`, true)
              setFieldTouched(`fares[${index}].dow`, true)
              setFieldTouched(`fares[${index}].demand`, true)
              setFieldTouched(`fares[${index}].salesChannel`, true)
              setFieldTouched(`fares[${index}].serviceType`, true)
            }

            const handleDeleteFare = (): TSFixMe => {
              const newFares = values.fares.filter((fare: TSFixMe, fareIndex: TSFixMe): TSFixMe => fareIndex !== index)

              setFieldValue('fares', newFares)
            }

            return (
              <Tr key={index}>
                <StyledTd isFirstRow={index === 0} largeInput>
                  <Input
                    id={`fares[${index}].taxonomy`}
                    onChange={handleTaxonomyChange}
                    onBlur={handleTaxonomyBlur}
                    value={fare.taxonomy}
                    disabled={fare.isTaxonomyDisabled}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={(fare.bookingClass && fare.bookingClass.name) || ''}
                    disabled
                    touched={touched.fares && touched.fares[index]?.bookingClass?.id}
                    errors={errors.fares && errors.fares[index]?.bookingClass?.id}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={(fareTypeMessages[fare.type] && intl.formatMessage(fareTypeMessages[fare.type])) || ''}
                    disabled
                    touched={touched.fares && touched.fares[index]?.type}
                    errors={errors.fares && errors.fares[index]?.type}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={
                      (seasonTypeMessages[fare.seasonType] &&
                        intl.formatMessage(seasonTypeMessages[fare.seasonType])) ||
                      ''
                    }
                    disabled
                    touched={touched.fares && touched.fares[index]?.seasonType}
                    errors={errors.fares && errors.fares[index]?.seasonType}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={fare.timeWindow}
                    disabled
                    touched={touched.fares && touched.fares[index]?.timeWindow}
                    errors={errors.fares && errors.fares[index]?.timeWindow}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={(dowMessages[fare.dow] && intl.formatMessage(dowMessages[fare.dow])) || ''}
                    disabled
                    touched={touched.fares && touched.fares[index]?.dow}
                    errors={errors.fares && errors.fares[index]?.dow}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={(demandMessages[fare.demand] && intl.formatMessage(demandMessages[fare.demand])) || ''}
                    disabled
                    touched={touched.fares && touched.fares[index]?.demand}
                    errors={errors.fares && errors.fares[index]?.demand}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={
                      (salesChannelMessages[fare.salesChannel] &&
                        intl.formatMessage(salesChannelMessages[fare.salesChannel])) ||
                      ''
                    }
                    disabled
                    touched={touched.fares && touched.fares[index]?.salesChannel}
                    errors={errors.fares && errors.fares[index]?.salesChannel}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Input
                    value={
                      (serviceTypeMessages[fare.serviceType] &&
                        intl.formatMessage(serviceTypeMessages[fare.serviceType])) ||
                      ''
                    }
                    disabled
                    touched={touched.fares && touched.fares[index]?.serviceType}
                    errors={errors.fares && errors.fares[index]?.serviceType}
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <InputCurrency
                    id={`fares[${index}].basePrice`}
                    value={sanitizePrice(fare.basePrice)}
                    placeholder="$0.00"
                    onChange={(value): TSFixMe => {
                      setFieldValue(`fares[${index}].basePrice`, value)
                    }}
                    onBlur={handleBlur}
                    touched={touched.fares && touched.fares[index]?.basePrice}
                    errors={errors.fares && errors.fares[index]?.basePrice}
                    hideSuffix
                    small
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  <Switch
                    value={fare.isActive}
                    onChange={(value): TSFixMe => setFieldValue(`fares[${index}].isActive`, value)}
                  />
                </StyledTd>
                <StyledTd isFirstRow={index === 0}>
                  {!fare.isTaxonomyDisabled && (
                    <TrashWrapper onClick={handleDeleteFare}>
                      <StyledTrashOIcon />
                    </TrashWrapper>
                  )}
                </StyledTd>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}

const AddFareWrapper = styled.div<TSFixMe>`
  margin-bottom: 10px;
`

const getFareByBookingClassAndFareType = (
  bookingClass: TSFixMe,
  fareType: TSFixMe,
  bookingClasses: TSFixMe
): TSFixMe => {
  const taxonomy = `${bookingClass.name}${fareType}N00N0EB`
  return {
    taxonomy,
    ...getFareByTaxonomy(taxonomy, bookingClasses)
  }
}

export const FaresList = (props: TSFixMe): TSFixMe => {
  let content
  const { values, setFieldValue, company = {} } = props
  const [getBookingClasses, { loading, error, data = {}, networkStatus }] = useLazyQuery(GET_BOOKING_CLASSES, {
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (isEmpty(values.fares)) {
        const fares = data.bookingClasses.map((bookingClass: TSFixMe): TSFixMe => {
          let faresByBookingClass: TSFixMe = []

          if (bookingClass.isActive) {
            faresByBookingClass = [
              ...faresByBookingClass,
              {
                ...getFareByBookingClassAndFareType(bookingClass, FARE_TYPE.NORMAL, data.bookingClasses),
                basePrice: '',
                isActive: true,
                isTaxonomyDisabled: true
              }
            ]

            if (bookingClass.promo) {
              faresByBookingClass = [
                ...faresByBookingClass,
                {
                  ...getFareByBookingClassAndFareType(bookingClass, FARE_TYPE.PROMO, data.bookingClasses),
                  basePrice: '',
                  isActive: true,
                  isTaxonomyDisabled: true
                }
              ]
            }
          }

          return faresByBookingClass
        })
        setFieldValue('fares', flatten(fares))
      }
    }
  })

  useEffect((): TSFixMe => {
    getBookingClasses({
      variables: {
        companyId: company.id
      }
    })
  }, [company.id])

  const handleAddFare = (): TSFixMe => {
    setFieldValue('fares', [
      ...values.fares,
      {
        taxonomy: '',
        ...getFareByTaxonomy('', data.bookingClasses),
        basePrice: '',
        isActive: true
      }
    ])
  }

  if (loading || networkStatus === NetworkStatus.refetch) {
    content = (
      <EmptyState.Container>
        <Loader />
      </EmptyState.Container>
    )
  } else if (error) {
    content = (
      <EmptyState.Container>
        <EmptyState.Description>
          <FormattedMessage
            id="bookingClasses.error.description"
            defaultMessage="There was an error while loading your booking classes"
          />
        </EmptyState.Description>

        <EmptyState.Action>
          <Button
            onClick={(): TSFixMe =>
              getBookingClasses({
                variables: {
                  companyId: company.id
                }
              })
            }
            kind="primary"
          >
            <FormattedMessage id="bookingClasses.error.action" defaultMessage="Reload your booking classes" />
          </Button>
        </EmptyState.Action>
      </EmptyState.Container>
    )
  } else {
    content = (
      <>
        <AddFareWrapper>
          <Button type="button" kind="secondary" onClick={handleAddFare}>
            <FormattedMessage id="fareFamilies.fare.add" defaultMessage="Add fare base" />
          </Button>
        </AddFareWrapper>

        <FaresTable {...props} bookingClasses={data.bookingClasses} />
      </>
    )
  }

  return <div>{content}</div>
}
